export default __webpack_public_path__ + "static/media/Janis_Melillo_AHV_In_Moms_We_Trust.a8c96afb.jpg";